import PropTypes from 'prop-types';
import TrackKeys from './TrackKeys';

const Body = ({ tracks, toggleTrackOpen, clickTrackButton }) => (
  <div>
    <TrackKeys
      tracks={tracks}
      toggleOpen={toggleTrackOpen}
      clickTrackButton={clickTrackButton}
    />
  </div>
);

Body.propTypes = {
  tracks: PropTypes.arrayOf(PropTypes.shape({})),
  toggleTrackOpen: PropTypes.func,
  clickTrackButton: PropTypes.func,
};

export default Body;
